import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Logo from 'assets/icons/finefinders-logo.svg';
import { PAGE_PATHS } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { userStateSelector } from '../../store/selectors';
import { useReduxActions } from 'hooks/useReduxActions';

const Login = () => {
  const userState = useSelector(userStateSelector);
  const { t } = useTranslation();
  const actions = useReduxActions();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = () => {
    actions.logIn({
      email,
      password,
    });
  };

  useEffect(() => {
    if (userState.isLoginLoading) {
      toast.loading(t('login.toast.loading.message'));
    }
    if (userState.error) {
      toast.dismiss();
      toast.error(userState.error.message);
    }
    if (userState.isLoggedIn) {
      toast.dismiss();
      toast.success(t('login.toast.success.message'));
    }
  }, [userState]); // eslint-disable-line

  if (userState.isLoggedIn) {
    return <Navigate to={PAGE_PATHS.PRODUCT} />;
  }

  return (
    <div className="login">
      <div className="side" />
      <div className="container">
        <div className="content-container mb">
          <img alt="Logo" src={Logo} />
          <p className="title">{t('login.welcome.text')}</p>
          <div className="input-container">
            <label>{t('login.email.label')}</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div className="input-container">
            <label>{t('login.password.label')}</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <div className="button-container">
            <button className="button" onClick={handleSubmit}>
              {t('login.button')}
            </button>
            <Link to={PAGE_PATHS.RESET_PASSWORD}>
              {t('login.forgot.password')}
            </Link>
          </div>
          <p className="bottom note" style={{ bottom: 128 }}>
            {t('login.not.registered.yet')}{' '}
            <Link to={PAGE_PATHS.REGISTER}>{t('login.register.here')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
